import React from "react";
import { X } from "@phosphor-icons/react";
import { fmtDay } from "./rules";

const Chip = ({ tone, children, onRemove, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 pl-3 pr-1.5 py-1 rounded-full border text-sm ${tone}`}>
    {children}
    <button type="button" onClick={onRemove} aria-label="Remove" data-testid={`${testId}-remove`} className="p-0.5 rounded-full hover:bg-black/10"><X size={12} /></button>
  </span>
);

export const EntriesList = ({ rule, today, onRemoveBlocked, onRemoveOpen }) => {
  const blocked = rule.blocked.map((b, i) => ({ ...b, i })).filter((b) => b.to >= today).sort((a, b) => a.from.localeCompare(b.from));
  const open = rule.open_dates.map((o, i) => ({ ...o, i })).filter((o) => o.date >= today).sort((a, b) => a.date.localeCompare(b.date));
  return (
    <div className="space-y-5" data-testid="availability-entries">
      <div>
        <div className="text-xs uppercase tracking-[0.16em] text-ink-muted mb-2">Not available ({blocked.length})</div>
        <div className="flex flex-wrap gap-2">
          {blocked.length === 0 && <span className="text-sm text-ink-muted/70">None coming up</span>}
          {blocked.map((b) => (
            <Chip key={b._k} tone="bg-red-50 border-red-200 text-red-800" onRemove={() => onRemoveBlocked(b.i)} testId={`entry-blocked-${b.from}`}>
              {b.from === b.to ? fmtDay(b.from) : `${fmtDay(b.from)} → ${fmtDay(b.to)}`}
            </Chip>
          ))}
        </div>
      </div>
      <div>
        <div className="text-xs uppercase tracking-[0.16em] text-ink-muted mb-2">Extra hours ({open.length})</div>
        <div className="flex flex-wrap gap-2">
          {open.length === 0 && <span className="text-sm text-ink-muted/70">None coming up</span>}
          {open.map((o) => (
            <Chip key={o._k} tone="bg-amber-50 border-amber-300 text-amber-900" onRemove={() => onRemoveOpen(o.i)} testId={`entry-open-${o.date}`}>
              {fmtDay(o.date)} · {o.from}–{o.until}
            </Chip>
          ))}
        </div>
      </div>
    </div>
  );
};
